<template>
  <div class="wrapper">
    <div id="environment-ribbon" :class="'banner-' + getEnvironment()">
      {{ getEnvironmentText() }}
    </div>
    <side-bar type="sidebar" :sidebar-links="$route.path.includes('management') || ($route.path.includes('documents') && $store.state.managerData && !$store.state.userData) ? $sidebar.managementSidebarLinks : $sidebar.sidebarLinks">
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      idleLogout () {
        let signOut = () => {
          window.removeEventListener('mousemove', resetTimer, true)
          window.removeEventListener('mousedown', resetTimer, true)
          window.removeEventListener('touchstart', resetTimer, true)
          window.removeEventListener('click', resetTimer, true)
          window.removeEventListener('keypress', resetTimer, true)
          window.removeEventListener('scroll', resetTimer, true)
          this.$http.post(this.$http.defaults.baseURL + '/client/logout')
          .then(response => {
            if (this.$store.state.managerData) {
              this.$store.state.managerData = null
              this.$store.state.userData = null
              this.$router.push('/managementLogin')
            } else {
              this.$store.state.userData = null
              this.$router.push('/')
            }
          })
        }

        let timeSinceMovement = setTimeout(signOut, 600000)

        let resetTimer = () => {
          clearTimeout(timeSinceMovement)
          timeSinceMovement = setTimeout(signOut, 600000)
        }
  
        window.addEventListener('mousemove', resetTimer, true)
        window.addEventListener('mousedown', resetTimer, true)
        window.addEventListener('touchstart', resetTimer, true)
        window.addEventListener('click', resetTimer, true)
        window.addEventListener('keypress', resetTimer, true)
        window.addEventListener('scroll', resetTimer, true)
      }
    },
    mounted () {
      this.idleLogout()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue